import { isEditableEventTarget } from './is-editable-event-target';
import { KeyShortcutBindings, KeyShortcutHandler } from './key-shortcuts-types';

export function formatShortcutLabel(
  label: string,
  shortcutKey?: string
): string {
  return shortcutKey ? `${label} (${shortcutKey})` : label;
}

export function hasModifierKey(event: KeyboardEvent): boolean {
  return event.ctrlKey || event.metaKey || event.altKey || event.shiftKey;
}

export function isModalDialogOpen(): boolean {
  return document.querySelector('[aria-modal="true"]') !== null;
}

export function resolveKeyShortcutHandler(
  event: KeyboardEvent,
  bindings: KeyShortcutBindings
): KeyShortcutHandler | undefined {
  if (event.repeat || hasModifierKey(event)) return undefined;
  if (isEditableEventTarget(event.target) || isModalDialogOpen()) {
    return undefined;
  }
  return bindings[event.key.toUpperCase()];
}
